/* eslint-disable react/no-danger */
// React
import React, { useState, useMemo, useCallback } from 'react';

// Components & Hooks
import Button from '@material-ui/core/Button';
import { ADGMImage, ADGMPanel, ADGMPanelInputsGeneratorBody, ADGMModal } from 'aurora-components';
// Utils
import PropTypes from 'prop-types';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { useClipboard } from 'aurora-hooks';
import { withStyles } from '@material-ui/core/styles';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
// styles
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import styles from './styles';

const Item = ({ isEditable, classes, item, index, editItem, removeItem }) => {
  return (
    <div className={classNames(classes.item)} key={`${index + 1}`}>
      <Box className={classes.itemContainer}>
        <span className={classes.index}>{index + 1}</span>
        {/* because sometimes we get html response */}
        <div dangerouslySetInnerHTML={{ __html: item?.term }} />
        {isEditable ? (
          <Box className={classes.itemActions} gridGap='1em'>
            <Button
              onClick={() => editItem(item)}
              variant='text'
              startIcon={<ADGMImage name='PencilRed.svg' alt='edit-pencil' width='14px' height='14px' />}
            >
              {keyEmptyCheck('Edit')}
            </Button>
            <span>
              <ADGMImage name='DividerRed.svg' alt='divider' className={classes.dividerImg} />
            </span>
            <Button
              onClick={() => removeItem(item)}
              variant='text'
              startIcon={<ADGMImage name='delete-pma.svg' alt='delete-dustbin' width='14px' height='14px' />}
            >
              {keyEmptyCheck('remove')}
            </Button>
          </Box>
        ) : (
          ''
        )}
      </Box>
    </div>
  );
};

Item.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  removeItem: PropTypes.func.isRequired,
  editItem: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

const ItemsListing = ({
  isEditable,
  classes,
  items,
  onAdd,
  onEdit,
  onRemove,
  title,
  section,
  seeMoreText,
  seeLessText,
  AddButtonLabel,
  handleExpertReportEditData,
  AddModalTitle,
  UpdateModalTitle,
  clearExpertReportData,
  ListHeading,
  disableButton,
  applicationNumber,
  primrayModalButtonLabel,
  ...props
}) => {
  const [entityCollapse, setEntityCollapse] = useState(true);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const onClose = () => {
    setOpen(false);
    setIsEdit(false);
    clearExpertReportData();
  };

  const onSubmit = useCallback(() => {
    isEdit ? onEdit() : onAdd();
    onClose();
  }, [isEdit, items]);

  const removeItem = selectedItem => {
    onRemove(selectedItem);
  };

  const editItem = selectedItem => {
    setOpen(true);
    setIsEdit(true);
    handleExpertReportEditData(selectedItem);
  };
  const data = useMemo(() => {
    return entityCollapse && items && !isEditable ? [...items]?.splice(0, 2) : items;
  }, [items, entityCollapse, isEditable]);
  const { copy } = useClipboard();
  return (
    <ADGMPanel
      title={title}
      hasPadding
      classes={{ containerPadding: classes.containerPadding, titleHead: classes.titleHead }}
      {...props}
    >
      {ListHeading ? (
        <Box component='p' className={classes.ListHeading}>
          {keyEmptyCheck(ListHeading)}
        </Box>
      ) : (
        ''
      )}

      {data &&
        data?.map((listItem, index) => {
          return (
            <Item
              removeItem={removeItem}
              item={listItem}
              editItem={editItem}
              index={index}
              key={listItem?.id}
              classes={classes}
              isEditable={isEditable}
            />
          );
        })}
      {isEditable ? (
        <Button
          variant='outlined'
          className={classes.addActionBtn}
          onClick={() => {
            clearExpertReportData();
            setIsEdit(false);
            setOpen(true);
          }}
        >
          <ADGMImage name='add-icon.svg' alt='add-icon' />
          {keyEmptyCheck(AddButtonLabel)}
        </Button>
      ) : (
        ''
      )}
      {!isEditable && !isEmpty(items) && items.length > 2 ? (
        <Box className={classes.viewMoreWrapper} textAlign='center' py='1em' borderBottom='1px solid #EBEEF3'>
          <Link onClick={() => setEntityCollapse(!entityCollapse)} color='#130F26'>
            {entityCollapse ? keyEmptyCheck(seeMoreText) : keyEmptyCheck(seeLessText)}
            {!entityCollapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Link>
        </Box>
      ) : (
        ''
      )}
      {/* {open && ( */}
      <ADGMModal className={classes.modalCls} open={open} onClose={onClose} toggleModal={onClose}>
        <Box className={classes.modalHeading}>
          <ADGMImage name='PreviousArrow.png' alt='LeftArrow' className={classes.PrevIcon} onClick={onClose} />{' '}
          <Typography variant='h6' component='h1' className={classes.modalTitle}>
            {isEdit ? keyEmptyCheck(UpdateModalTitle) : keyEmptyCheck(AddModalTitle)}
          </Typography>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={onClose}
          />
        </Box>

        <Box className={classes.grayBox}>
          <div className={classes.gratTextColor}>
            <Typography variant='body1'>
              {keyEmptyCheck('Application_ID')}:{' '}
              <span className={classes.fontWeight600}>
                {applicationNumber}
                <ADGMImage
                  onClick={() => copy(applicationNumber)}
                  className={classes.copyRightEvent}
                  name='ApplicationIDicon.svg'
                  alt='ApplicationIDicon'
                />
              </span>
            </Typography>
          </div>
          <div className={classes.modalTitleText}>
            {keyEmptyCheck(AddModalTitle)} <span className={classes.redStar}>*</span>
          </div>
        </Box>
        <ADGMPanelInputsGeneratorBody
          classes={{
            containerPadding: classes.modalContainerModified,
            label: classes.labelCls,
          }}
          isEditable
          sections={section}
        />

        <Box display='grid' gridGap='1em' className={classNames(classes.actionsBtnContainer)}>
          <Box>
            <Button variant='outlined' onClick={onClose}>
              {keyEmptyCheck('discard')}
            </Button>
          </Box>
          <Box>
            <Button
              variant='contained'
              color='primary'
              onClick={onSubmit}
              className={classes.adgmRedBtn}
              disabled={disableButton}
            >
              {isEdit ? keyEmptyCheck('update') : keyEmptyCheck(primrayModalButtonLabel)}
            </Button>
          </Box>
        </Box>
      </ADGMModal>
      {/* )} */}
    </ADGMPanel>
  );
};

ItemsListing.propTypes = {
  classes: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  seeMoreText: PropTypes.string.isRequired,
  seeLessText: PropTypes.string.isRequired,
  AddButtonLabel: PropTypes.string.isRequired,
  handleExpertReportEditData: PropTypes.func.isRequired,
  AddModalTitle: PropTypes.string.isRequired,
  UpdateModalTitle: PropTypes.string.isRequired,
  clearExpertReportData: PropTypes.func.isRequired,
  ListHeading: PropTypes.string.isRequired,
  disableButton: PropTypes.bool.isRequired,
  applicationNumber: PropTypes.string,
  primrayModalButtonLabel: PropTypes.string,
};

ItemsListing.defaultProps = {
  applicationNumber: '',
  primrayModalButtonLabel: 'submit',
};

export default withStyles(styles)(ItemsListing);
